import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const ProposalFilesModule = lazy(loadModule);

export default ProposalFilesModule;
